// Content shared by the Habitation Velier page and its structured data (FAQPage)

export const HV_IMAGE = '/image/habitation-velier-83-islands-2021.jpg'

export const hvSpecs = [
  { label: 'Bottler', value: 'Habitation Velier' },
  { label: 'Distillery', value: '83 Islands Distillery, Port Vila, Vanuatu' },
  { label: 'Classification', value: 'Pure Single Rum (Oceania)' },
  { label: 'Raw material', value: 'Fresh sugarcane juice' },
  { label: 'Fermentation', value: '8 to 10 days' },
  { label: 'Distillation', value: '100% pot still,\ndistilled in a Müller steam bain‑marie pot still' },
  { label: 'Cask', value: 'Ex-bourbon' },
  { label: 'Distilled', value: '2021' },
  { label: 'Bottled', value: '2026' },
  { label: 'Age', value: '5 years, aged entirely in the tropics' },
  { label: "Angels' share", value: 'More than 29%' },
  { label: 'Esters', value: '95.8 g/hlpa' },
  { label: 'Strength', value: '53% ABV, barrel proof' },
  { label: 'Additives', value: 'No sugar added' },
  { label: 'Size', value: '70 cl' },
  { label: 'Edition', value: '1,500 bottles' },
  { label: 'Distribution', value: 'La Maison du Whisky exclusive' }
]

export const hvFaqs = [
  {
    q: 'What is Habitation Velier?',
    a: 'Habitation Velier is the rum range Luca Gargano of Velier started in 2015. It only bottles pot still rum, bottled at cask strength with no sugar or colouring. Each label shows the still the rum came from and how it was made.'
  },
  {
    q: 'What is a Pure Single Rum?',
    a: 'In the Gargano Classification, a Pure Single Rum is distilled 100% in a batch pot still at a single distillery, much like a single malt in Scotch whisky.'
  },
  {
    q: 'How many bottles of Habitation Velier 83 Islands 2021 were released?',
    a: 'The release is a limited edition of 1,500 bottles of 70 cl, distributed exclusively through La Maison du Whisky.'
  },
  {
    q: 'How is Habitation Velier 83 Islands 2021 made?',
    a: 'Fresh sugarcane juice from Efate, fermented for eight to ten days and distilled in a Müller steam bain-marie pot still at 83 Islands Distillery in Port Vila. It was aged five years in ex-bourbon casks in Vanuatu and bottled in 2026 at 53% barrel proof, with 95.8 g/hlpa of esters and an angels’ share above 29%.'
  },
  {
    q: 'Where can I buy Habitation Velier 83 Islands 2021?',
    a: 'It is a La Maison du Whisky exclusive, available from whisky.fr and from rum specialists such as Excellence Rhum in France and Spirit Academy in Italy.'
  },
  {
    q: 'Is this the first Habitation Velier from Vanuatu?',
    a: 'Yes. It was released with a Fiji rum as the first two Habitation Velier rums from the South Pacific. 83 Islands is the first and only rum distillery in Vanuatu.'
  }
]
